import React from "react";

// eslint-disable-next-line no-restricted-imports
import { Checkbox as BaseCheckbox, CheckboxProps } from "@packages/ds";

import { trackEventPendo, createUIAnalyticsEvent } from "Libs/analytics";

interface TrackedCheckboxProps extends Omit<CheckboxProps, "onCheckedChange"> {
  analyticId?: string;
  // maintain original API to avoid having to change all usages
  onCheckedChanged?: (checked: boolean) => void;
}

export const TrackedCheckbox = ({
  analyticId,
  id,
  forId,
  onCheckedChanged,
  label,
  ...props
}: TrackedCheckboxProps) => {
  const handleCheckedChange = (checked: boolean) => {
    // Use analyticId if provided, otherwise fallback to id or forId, which is what was used in the past
    const trackingId = analyticId || id || forId;

    if (trackingId) {
      trackEventPendo(
        createUIAnalyticsEvent.checkbox.clicked(
          String(label),
          checked,
          trackingId
        )
      );
    }
    onCheckedChanged?.(checked);
  };

  return (
    <BaseCheckbox
      {...props}
      id={id}
      forId={forId}
      label={label}
      onCheckedChange={handleCheckedChange}
    />
  );
};
